//english version

//const CGOSERVICE_HOST = "http://cloud.01fit.com";
//const ENTSERVICE_HOST = "https://search.iwown.com/hpmservice";
//const FILESERVICE_HOST = "https://api8.iwown.com";
//const NGGSERVICE_HOST = "https://api1.iwown.com/nggservice";

const CGOSERVICE_HOST = "http://cgoservice-850317709.us-west-1.elb.amazonaws.com";
const ENTSERVICE_HOST = "https://euapi.iwown.com/hpmservice";
const FILESERVICE_HOST = "https://jpapi.iwown.com";
const NGGSERVICE_HOST = "https://api11.iwown.com/nggservice";

export default {
  URLS: {
    Login_Url: ENTSERVICE_HOST + "/client/login",
    DeviceList_4G_Url: ENTSERVICE_HOST + "/device/active_list/v2",
    DeviceList_BLE_Url: ENTSERVICE_HOST + "/device/ble/active_list",

    DeviceStatus_4G_Url: ENTSERVICE_HOST + "/device/status",

    UserInfo_4GDevice_Url: ENTSERVICE_HOST + "/device/userinfo",
    UserInfo_BLE_Url: ENTSERVICE_HOST + "/user/userinfo",

    Sync_Device_DataCmd_Url: ENTSERVICE_HOST + "/cmd/datasync",

    afLatest: ENTSERVICE_HOST + "/af/ai",
    afBleLatest: ENTSERVICE_HOST + "/af/ble/ai",

    hrdataUrl: ENTSERVICE_HOST + "/hr/history/download",
    hrBledataUrl: ENTSERVICE_HOST + "/hr/ble/history/download",

    gnssDataUrl: ENTSERVICE_HOST + "/gnss/history/download",
    gnssWholeDayListUrl: ENTSERVICE_HOST + "/device/gnss/daily/list",

    ecgAIUrl: ENTSERVICE_HOST + "/ecg/ai_result/download",
    ecgBleAIUrl: ENTSERVICE_HOST + "/ecg/ble/ai_result/download",

    hrDetailDataUrl: ENTSERVICE_HOST + "/hr/detail/download",
    hrBleDetailDataUrl: ENTSERVICE_HOST + "/hr/ble/detail/download",

    AF_RESULT: FILESERVICE_HOST + "/cloud/rri",
    AF_BLE_RESULT: ENTSERVICE_HOST + "/af/ble/data/download",

    AtrialFibration_24hoursUrl: ENTSERVICE_HOST + "/af/24hours",
    AtrialFibration_7daysUrl: ENTSERVICE_HOST + "/af/7days",

    Get_Today_Af_Result: ENTSERVICE_HOST + "/af/ai/v2",

    ecgDataListUrl: ENTSERVICE_HOST + "/ecg/history/download/v2",
    ecgAIAnalyzeUrl: CGOSERVICE_HOST + "/sport/ecg/aiAnalysis",
    ecgDetailDataUrl: ENTSERVICE_HOST + "/ecg/rawdata/download",

    ecgBleDataListUrl: ENTSERVICE_HOST + "/ecg/ble/history/download/v2",
    ecgBleDetailDataUrl: ENTSERVICE_HOST + "/ecg/ble/rawdata/download",

    sportHourlyDataUrl: ENTSERVICE_HOST + "/sport/hourly/download",
    sportDetailDataUrl: ENTSERVICE_HOST + "/sport/detail/download",
    sportBleHourlyDataUrl: ENTSERVICE_HOST + "/sport/ble/hourly/download",
    sportBleDetailDataUrl: ENTSERVICE_HOST + "/sport/ble/detail/download",

    sleepDataUrl: ENTSERVICE_HOST + "/sleep/history/download/v2",
    sleepBleDataUrl: ENTSERVICE_HOST + "/sleep/ble/history/download/v2",

    all_latest_gnss_url: ENTSERVICE_HOST + "/gnss/all/latest",

    device_alarm_url: ENTSERVICE_HOST + "/device/alarm/list",

    Update_WearInfo_Url: NGGSERVICE_HOST + "/device/4g/wearinfo/update",

    Group_Message_url: ENTSERVICE_HOST + "/device/cmd/group/message",

    Reset_Device_url: ENTSERVICE_HOST + "/device/cmd/all/reset",
  },
};
